import { Fragment, useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { faLongArrowAltLeft, faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useApi from "utils/hooks/useApi";
import { useLoader } from "utils/context/loaderContext";
import InfoColumn from "components/ui/infoColumn/infoColumn";

const DetailsActivity = () => {
  const api = useApi();
  const [loader] = useLoader();

  const { id: idActivity } = useParams();
  const history = useHistory();

  const [activity, setActivity] = useState({});

  const getData = useCallback(() => {
    if (!idActivity) return;
    loader.set();
    api
      .get("cat/act", { params: { id: idActivity } })
      .then(setActivity)
      .catch(console.error)
      .finally(loader.stop);
  }, [api, idActivity, loader]);

  useEffect(getData, [getData]);

  return (
    <div className="row">
      <div className="col">
        <div className="card">
          <div className="card-header">
            <div className="left">
              <button type="button" className="btn btn-link" onClick={() => history.goBack()}>
                <FontAwesomeIcon icon={faLongArrowAltLeft} />
              </button>
              <h5>Información de actividad</h5>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <InfoColumn
                colSize="col-12 col-md-4"
                title="Actividad"
                info={
                  <Fragment>
                    <span className="me-2">#{activity?.id}</span>
                    <span className={`badge ${activity?.activo ? "bg-success" : "bg-danger"}`}>
                      <FontAwesomeIcon icon={activity?.activo ? faToggleOn : faToggleOff} />
                    </span>
                  </Fragment>
                }
              />
              <InfoColumn colSize="col-12 col-md-4" title="Nombre" info={activity?.nombre_act} />
              <InfoColumn colSize="col-12 col-md-4" title="Tipo de actividad" info={activity?.tipo_actividad} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsActivity;
